export const TOS_VERSION = 'terms-2026-07-21';
export const PRIVACY_VERSION = 'privacy-2026-07-21';
